import { useQuery } from '@tanstack/react-query';
import { get } from '@shared/typedApi';
import routes from '@root/routes';
import { isNull } from 'lodash';
import { AdminMicrosite } from '@root/types';
import { Spinner } from '@components/shared';
import NewMicrosite from './NewMicrosite';
import EditMicrosite from './EditMicrosite';

type Props = {
  buildingId: string;
};

export default function Microsite({ buildingId }: Props) {
  const {
    data: microsite,
    isLoading,
    refetch,
  } = useQuery<AdminMicrosite | null>([routes.api.admin.buildingMicrosite(buildingId)], () =>
    get(routes.api.admin.buildingMicrosite(buildingId)),
  );

  if (isLoading) return <Spinner />;

  return isNull(microsite) ? (
    <NewMicrosite buildingId={buildingId} refetch={refetch} />
  ) : (
    <EditMicrosite buildingId={buildingId} microsite={microsite!} refetch={refetch} />
  );
}
